import React from 'react';

const Dropdown = (props) => {
  const checkIfDisabled =
    props.checkIfDisabled || ((i) => (props.min && i < props.min) || (props.max && i > props.max));

  const options = props.options.map((i) => (
    <option key={i} value={i} disabled={checkIfDisabled(i)}>
      {props.optionTextFormatter ? props.optionTextFormatter(i) : i}
    </option>
  ));

  return (
    <div className="dropdown ">
      <select
        className="dropdown__select"
        name={props.name}
        value={props.value || 'none'}
        onChange={props.updateSelection}
      >
        <option value="none">{props.noneSelected}</option>
        {options}
      </select>
    </div>
  );
};

export default Dropdown;
